<template>
  <dash-page-new :title="$t('Products') + (selectedCategoryName ? (': ' + selectedCategoryName) : '')"
                 :root="$t('Dashboard')"
                 :subtitle="$t('AllProducts')"
                 :root-location="businessDashLink('')"
                 icon="mdi-school"
                 no-side>

    <template #header_action.desktop>
      <v-btn v-if="itemsFiltered.length > 0 &&  MODULE_PERMISSIONS(['products'])" style="font-size: 13px; line-height: 1"  @click="openAddItem" dark class="noCaps " :color="wsATTENTION">
        <div class="d-flex align-center">
          <v-icon class="mr-2" size="20" >mdi-plus</v-icon>
          {{$t('AddProduct')}}
        </div>
      </v-btn>
    </template>
    <template #header_action.mobile>
      <v-btn v-if="itemsFiltered.length > 0"  icon
             @click="openAddItem"  :color="wsATTENTION">
        <v-icon class="mr-2" large  >mdi-plus-circle</v-icon>
      </v-btn>
    </template>

    <template #default>

      <v-row  no-gutters  style="flex-wrap: nowrap; height: 100% !important" class="fill-height mt-5"  >
        <!-- Categories-->
        <v-col :style="`min-width: ${categoriesWidth}px; max-width: ${categoriesWidth}px; height: 100% !important;`"
               style="transition: all 0.3s ease"
               class="pr-4 pb-6 flex-grow-0 flex-shrink-0 sideTransition fill-height"
        >

          <v-sheet v-if="!hideCategories"
                   class="fill-height wsRoundedLight overflow-y-auto"
                   :style="`border : 1px solid ${wsBACKGROUND}`"
          >
            <v-sheet :color="wsLIGHTCARD" height="46"
                     class="d-flex  wsRoundedLight align-center"
                     :class="!hideCategories ? 'px-2 justify-space-between' : 'justify-center'"
            >
              <ws-tooltip v-if="!hideCategories && MODULE_PERMISSIONS(['MODULE_WESTUDY__EDITOR'], true)" :text="$t('AddCategory')">
                <v-btn :color="wsACCENT"  @click="addCategoryItem('category')" icon>
                  <v-icon >mdi-folder-plus-outline</v-icon>
                </v-btn>
              </ws-tooltip>

              <h4 v-if="!hideCategories" :class="MODULE_PERMISSIONS(['MODULE_WESTUDY__EDITOR'], true) ? 'pl-4' : '' " > {{ $t('Categories') }}</h4>

              <v-btn @click="hideCategoriesAction" :color="wsACCENT" icon><v-icon>mdi-chevron-{{ !hideCategories ?  'left' : 'right' }}</v-icon></v-btn>

            </v-sheet>

            <v-divider   :style="`border-color : ${wsBACKGROUND}`" ></v-divider>

            <template  v-for="(item,i) in rootCategories">
              <v-sheet v-if="!hideCategories" height="48"  :key="'parent_category_' + i">
                <v-hover v-slot="{hover}" >

                  <div class="fill-height">
                    <v-sheet
                        @click="selectCategory(item)"
                        :color="hover || selectedCategory === item.value ? wsLIGHTCARD : ''"
                        :style="`border-bottom : 1px solid ${wsBACKGROUND}`"
                        class="d-flex align-center justify-space-between px-4 fill-height"
                        :class="[{'pointer' : childCategories(item.value).length === 0}]"
                    >
                      <h5 :style="`color : ${wsACCENT}`" class="d-flex align-center">
                        {{  item.text  }}
                        <wsAddItem
                            v-if="item.value !== 'all' && item.value !== 'unsorted' && MODULE_PERMISSIONS(['MODULE_WESTUDY__EDITOR'], true)"
                            inline
                            @input="editCategoryAction($event,item)"
                            :hover="hover"
                            :items="categodyAddItemsSelect"
                        />

                      </h5>
                      <h5>{{  courseCategoryCount(item.value)  }}</h5>
                    </v-sheet>



                  </div>

                </v-hover>
              </v-sheet>
              <template v-for="(child,i) in childCategories(item.value)">
                <v-sheet  v-if="!hideCategories"
                          height="48"  :key="'child_category_' + i">
                  <v-hover v-slot="{hover}" >

                    <div class="fill-height">
                      <v-sheet
                          @click="selectedCategory = child.value"
                          :color="hover || selectedCategory === item.value ? wsLIGHTCARD : ''"
                          :style="`border-bottom : 1px solid ${wsBACKGROUND}`"
                          class="d-flex align-center justify-space-between px-4 fill-height pointer"
                      >
                        <h5 class="pl-6 d-flex align-center" >
                          {{  child.text  }}
                          <wsAddItem
                              v-if="MODULE_PERMISSIONS(['MODULE_WESTUDY__EDITOR'], true)"
                              @input="editCategoryAction($event,child)"
                              :hover="hover"
                              inline
                              :items="categodyAddSubItemsSelect"
                          />
                        </h5>
                        <h5 >{{  courseCategoryCount(child.value)   }}
                        </h5>
                      </v-sheet>
                    </div>

                  </v-hover>


                </v-sheet>
              </template>

            </template>



          </v-sheet>
          <ws-tooltip v-else  :text="$t('Categories')">
            <v-btn @click="hideCategoriesAction" :color="wsACCENT" icon><v-icon>mdi-file-tree</v-icon></v-btn>
          </ws-tooltip>


        </v-col>
        <!-- Courses Table-->
        <v-col style="min-width: 100px; max-width: 100%;" class="flex-grow-1 flex-shrink-0 pb-6">

          <v-sheet class="fill-height overflow-y-auto wsRoundedLight"     :style="`border : 1px solid ${wsBACKGROUND}`">
            <ws-data-table
                v-if="itemsFiltered.length > 0"
                :items="itemsFiltered"
                :headers="headers"
            >

              <template v-slot:item="{ item  }">
                <v-hover v-slot="{hover}">
                  <tr @click="openEditItem(item)"
                      @contextmenu="openContextMenu($event, item)"
                      :style="`background : ${ hover ? wsLIGHTCARD : ''} !important`"
                      style="cursor: pointer !important;"
                  >

                    <td :style="`border-color: ${wsBACKGROUND}`">
                        <div class="d-flex align-center linkHover">
                          <h5 :style="`color : ${wsACCENT}`">{{ item.name }}</h5>
                        </div>
                    </td>
                    <td>
                      <h5> {{ item.price }}</h5>
                    </td>
                    <td width="150px" align="center">
                      <v-chip small :color="!item.disabled ? 'green lighten-1' : 'grey'" outlined>
                        <h5>{{ !item.disabled ?   $t('Active') : $t('NotActive')  }} </h5>
                      </v-chip>
                    </td>
                  </tr>
                </v-hover>
              </template>


            </ws-data-table>
            <div v-else
                 class="wsRoundedLight
         d-flex
         fill-height
         justify-center
         align-center
         pb-16 pt-8 py-6 " >

              <v-sheet  width="600">

                <div class="d-flex justify-center">
                  <v-icon size="80" :color="wsDARKLIGHT" >mdi-basket-plus</v-icon>
                </div>
                <h3 style="font-size: 22px; font-weight: 700" class="text-center  my-6">
                  <span v-if="items.length === 0">{{ $t('DashNoProductsYet') }}</span>
                  <span v-else-if="itemsFiltered.length === 0">{{ $t('DashNoCategoryProductsYet') }}</span>
                </h3>
                <div class="d-flex justify-center">
                  <v-btn height="40" @click="openAddItem" dark :color="wsATTENTION" class="noCaps">
                    <v-icon>mdi-plus</v-icon>
                    {{ $t('AddProduct') }}

                  </v-btn>
                </div>
              </v-sheet>

            </div>
          </v-sheet>

        </v-col>

      </v-row>

    </template>

    <template #dialog>
      <!-- Add / Edit Item Dialog Window -->
      <wsDialog v-model="displayDialog"
                :loading="LOADING"
                width="700"
                @save="addEditItem"
                :title="$t('CreateNewCSaveourse')"
                :saveText="$t('Save')"
                :cancel-action="newCourseStep === 1"
                :cancel-text="cancelText"
                @cancel="newCourseStep = 0 ; newCourseNavigation = 'description'"
                :showDelete="!newEntity"
                @delete="deleteItem" >

        <div v-if="(selectedCategory === 'all' || selectedCategory === 'unsorted') && categories.length > 0 " class="pb-2">
          <v-row class="pb-2 px-0 mx-0">
            <v-col cols="6" class="px-0 pr-1">
              <ws-select
                  v-model="entityData.category_id"
                  :items="rootCategoriesSelect"
                  :label="$t('Category')"
                  :placeholder="$t('ChooseCategory')"
                  :error="categoryError"
                  @input="categoryError = false"
              />
            </v-col>
            <v-col cols="6" class="px-0 pl-1">
              <v-expand-x-transition>
                <ws-select
                    v-if="childCategories(entityData.category_id).length > 0"
                    v-model="entityData.sub_category_id"
                    :items="childCategories(entityData.category_id)"
                    :label="$t('SubCategory')"
                    :placeholder="$t('ChooseSubCategory')"
                />
              </v-expand-x-transition>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col cols="9">
            <ws-text-field
                :label="$t('Name')"
                :placeholder="$t('ProductName')"
                v-model="entityData.name"
                :error="nameError"
                @input="nameError = false"
            />
          </v-col>
          <v-col cols="3">
            <ws-text-field
                :label="$t('Price')"
                :placeholder="$t('Price')"
                number
                v-model="entityData.price"
                :error="priceError"
                @input="priceError = false"
            />
          </v-col>
        </v-row>
        <ws-text-field
            class="mt-6"
            v-model="entityData.short_description"
            :label="$t('ShortDescription')"
            :placeholder="$t('EnterProductShortDescription')"
            height="100"
            counter="100"
            area
        />

<!--        <ws-file-uploader public image @success="entityData.img = $event.uuid"   />-->


      </wsDialog>
      <ft-select :expanded="displayContextMenu" :x="x" :y="y" absolute  @input="editCourseAction($event)" :items="editCourseActionsSelect" />

      <wsDialog
          v-model="displayCategoryDialog"
          :title="editCategory ? $t('EditCategory') : $t('AddCategory')"
          @save="addEditCategory"
      >
        <ws-text-field
            v-model="entityData.name.ua"
            :label="$t('Name')"
            :placeholder="$t('EnterName')"
        />

      </wsDialog>
    </template>

  </dash-page-new>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: "PageCourses",
  components : {
  },
  data() {
    return {
      //context menu
      hideCategories : false,
      categoriesWidth : 280,
      selectedCourse : {},
      displayContextMenu : false,
      x : null,
      y : null,

      newCourseNavigation : 'description',
      categories : [],
      selectedCategory : 'all',
      displayCategoryDialog : false,
      editCategory : false,
      priceError : false,
      nameError : false,
      categoryError : false,


      loading : false,
      newCourseStep : 0,
      items : [],
      dialogType : 'new',
      newEntity  : true,
      displayDialog : false,
      entityData : {
        name : '',
        short_description : '',
        price : 0,
      },
      newEntityData : {},
      entityDataDefault : {
        name : '',
        short_description : '',
        lang : 'ua',
        alias : '',
        payed : false,
        online : false,
        has_payment_plans : false
      },
    }
  },
  computed : {

    editCourseActionsSelect() {
      return [
        { text : this.$t('CourseEditor') , route : `courses/${this.selectedCourse.uuid}/editor`, icon : 'mdi-pencil' },
        { text : this.$t('ChangeCategory') , value : 'category' , icon : 'mdi-folder-multiple', children : this.categories_select },
      ]
    },

    pageNavigationFiltered() {

      let items = this.COURSE_NAVIGATION_ADMIN(this.$store.state.courses.course)
      items = items.filter(el => !el.permission || this.MODULE_PERMISSIONS([el.permission], true))

      return items

    },

    categories_select() {
      let result = []
      let items = JSON.parse(JSON.stringify(this.rootCategories))
      items.splice(0,1)
      items.splice(items.length -1 ,1)
      items.forEach(item => {
        item.icon = 'mdi-folder-outline'

        let subCategories = this.childCategories(item.value)
        if ( subCategories.length > 0) {
          item.icon = 'mdi-folder-multiple-outline'
          item.noAction = true
          result.push(item)
          subCategories.forEach(child => {
            child.icon = 'mdi-chevron-right'
            result.push(child)
          })

        } else {
          result.push(item)
        }
      })
      return result;
    },
    newCourseNavigationItems() {
      return [
        { text : this.$t('Description') , value : 'description' },
        { text : this.$t('Settings') , value : 'settings' },
      ]
    },
    selectedCategoryName() {
      if (this.categories.length === 0 ) {
        return ''
      }

      let category = this.categories.find( el=> el.value === this.selectedCategory )

      return category ? category.text : ''

    },
    categodyAddItemsSelect() {
      return [
        { text : this.$t('EditName') , value : 'edit' , icon : 'mdi-pencil' },
        { text : this.$t('AddSubCategory') , value : 'sub_category' , icon : 'mdi-folder-multiple-plus-outline' },
        { text : this.$t('Delete') , value : 'delete'        , icon : 'mdi-delete-outline' },
      ]
    },
    categodyAddSubItemsSelect() {
      return [
        { text : this.$t('EditName') , value : 'edit' , icon : 'mdi-pencil' },
        { text : this.$t('Delete') , value : 'delete'        , icon : 'mdi-delete-outline' },
      ]
    },
    headers() {
      return [
        { text  : this.$t('Name') , value : 'name' },
        { text  : this.$t('Price') , value : 'price' },
        { text  : this.$t('Status') , value : 'active'  }
      ]
    },
    saveText() {
      if ( !this.newEntity ) { return this.$t('Save')  }
      if ( this.newCourseStep === 0 ) { return this.$t('Next') }
      if ( this.newCourseStep === 2 && !this.LOADING ) { return this.$t('GoToCourseEdit') }


      return this.$t('Save')
    },
    cancelText() {
      if ( this.newCourseStep === 2 ) { return this.$t('Close') }
      return this.newCourseStep === 1 ? this.$t('GoBack') : this.$t('Cancel')
    },
    rootCategories() {
      if ( this.categories.length === 0 ) {
        return [{text: this.$t('All'), value: 'all'}]
      }
      let items = this.categories.filter( el => el.parent === null )
      items.unshift({text: this.$t('All'), value: 'all'} )
      items.push({text: this.$t('UnsortedCourses'), value: 'unsorted'} )
      return items
    },
    rootCategoriesSelect() {
      if (this.categories.length === 0) {
        return
      }
      let items = JSON.parse(JSON.stringify(this.rootCategories))
      items.splice(items.length - 1 , 1)
      return items
    },
    itemsFiltered() {
      let items = this.items
      if (this.selectedCategory && this.selectedCategory !== 'all') {
        let category = this.selectedCategory !== 'unsorted' ? this.selectedCategory : null
        items = items.filter( el => el.category_id === category )
      }
      return items
    }
  },
  methods : {
    ...mapActions('products', [
        'GET_PRODUCTS_ADMIN',
        'ADD_EDIT_PRODUCT'
    ]),


    gotoCourseRoute(uuid) {



      if (this.pageNavigationFiltered.length === 0 ) {
        return 'courses/'
      }

      return this.MODULE_PERMISSIONS(['MODULE_WESTUDY__EDITOR'], true)
          ? 'courses/' + uuid + '/' + this.$store.state.courses.navigationAdmin
          : 'courses/' + uuid + '/' + this.pageNavigationFiltered[0].value
    },

    hideCategoriesAction() {
      if (this.hideCategories) {
        this.hideCategories = false
        this.categoriesWidth = 280
        return
      }
      if (!this.hideCategories) {
        this.hideCategories = true
        this.categoriesWidth = 50
        return
      }
    },

    async editCourseAction(action) {
      let data = {
        uuid : this.selectedCourse.uuid,
        category_id : action
      }
      let result = await this.CHANGE_COURSE_CATEGORY(data)
      if ( !result ) {
        return
      }
      let index = this.items.findIndex( el => el.uuid === this.selectedCourse.uuid )
      if ( index === -1 ) {
        return
      }
      this.items[index].category_id = action
      this.notify(this.$t('CourseCategoryChanged'))
    },
    openContextMenu($event, course) {
      if (this.categories.length === 0 ) {
        return
      }
      this.selectedCourse = course
      $event.preventDefault()
      this.displayContextMenu = false
      this.x = $event.clientX
      this.y = $event.clientY
      this.$nextTick(() => {
        this.displayContextMenu = true
      })
    },

    selectCategory(item) {
      if ( this.childCategories(item.value).length === 0 ) {
        this.selectedCategory = item.value
      }
    },
    async addEditCategory() {

      let result = await this.ADD_COURSE_CATEGORY(this.entityData)
      if ( !result ) {
        return
      }
      if ( !this.editCategory ) {
        this.categories.push(result)
      }
      else {

        let index = this.categories.findIndex( el=> el.value === result.value )
        if ( index === -1 ) {
          return
        }
        this.categories[index].text = result.text
        this.categories = JSON.parse(JSON.stringify(this.categories))
      }

      this.displayCategoryDialog = false
    },
    async deleteCategory(item) {
      let result = await this.DELETE_COURSE_CATEGORY(item.value)
      if ( !result ) {
        return
      }

      this.categories = this.categories.filter( el=> el.value !== item.value )
      let categoriesArray = this.categories.filter( el=> el.parent === item.value )
      this.categories = this.categories.filter( el=> el.parent !== item.value )
      categoriesArray = categoriesArray.map(el => el.value)
      categoriesArray.push(item.value)
      this.items.forEach(course => {
        if ( categoriesArray.includes(course.category_id) ) {
          course.category_id = null
        }
      })
      if ( this.selectedCategory === item.value ) {
        this.selectedCategory = 'all'
      }
    },

    editCategoryAction($event, item) {

      if ( $event === 'edit' ) {
        this.editCategory = true
        this.entityData = {
          name : { ua : item.text },
          uuid : item.value
        }
        this.displayCategoryDialog = true
      }
      if ( $event === 'delete' ) {
        this.deleteCategory(item)
      }
      if ( $event === 'sub_category' ) {
        this.editCategory = false
        this.entityData = {
          name : { ua : '' },
          parent : item.value
        }
        this.displayCategoryDialog = true
      }
    },
    addCategoryItem($event, item ) {
      let type = ''
      if ( item && item.value ) {
        type = $event ===  'sub_category' ? item.value : null
      }

      this.editCategory = false
      this.entityData = {
        name : { ua : '' },
        parent : type
      }
      this.displayCategoryDialog = true
    },

    validateName() {
      let data = 0;
      Object.keys(this.entityData.name).forEach(lang=> {
        if ( this.entityData.name[lang] ) {
          data++;
        }
      })
      return data > 0
    },
    nextStep() {
      if ( !this.validateName() ) {
        this.nameError = true
        return this.notify(this.$t('CourseNameIsEmpty') )
      }
      // if ( this.IS_BUSINESS_MANAGER && this.MODULE_PERMISSIONS(['MODULE_WESTUDY__IS_LIMITED'], true) && !this.entityData.category_id ) {
      //   this.categoryError = true
      //   return this.notify(this.$t('CourseCategoryNotSet'))
      // }
      if ( this.newCourseStep === 0 ) {
        this.newCourseNavigation = 'settings'
      }
      if ( this.newCourseStep === 1 ) {
        if (this.entityData.payed && !this.entityData.has_payment_plans && !this.entityData.price ) {
          this.priceError = true
          return this.notify(this.$t('PriceNotSet'))
        }
      }
      this.newCourseStep++
      if ( this.newCourseStep === 2 ) {
        this.addEditItem()
      }
      if(this.newCourseStep === 3 ) {
        this.$router.push(this.businessDashLink(this.gotoCourseRoute(this.newEntityData.uuid)))
      }
    },

    // Entity functions
    addEditItem() {

      this.newEntity
          ? this.newItem(this.ADD_EDIT_PRODUCT(this.entityData))
          : this.changeItem(this.ADD_EDIT_PRODUCT(this.entityData))

    },
    deleteItem() {

      this.removeItem(this.DELETE_COURSE(this.entityData.uuid) )
      this.displayDialog = false

    },

    // Reactivity functions
    async changeItem(request) {

      let item = await request

      if ( item ) {
        var index = this.items
            .findIndex(el => el.uuid === item.uuid )
        this.items[index] = item
        this.$set(this.items,index,item)
        this.notify( this.$t('ChangesSaved')  )
      }

      this.displayDialog = false

    },
    async newItem(request) {

      let item = await request

      if ( item ) {
        this.items.push( item )
        this.notify( this.$t('NewProductCreated' ))
      }
      this.displayDialog = false


    },
    async removeItem(deleteAction) {

      if ( !await deleteAction ) {
        return this.notify(this.$t('EntityCannotBeDeleted'))
      }

      var index = this.items
          .findIndex(el => el.uuid === this.entityData.uuid )
      this.items.splice(index,1)
      this.notify(this.$t('CourseDeleted'))

    },

    // Dialog functions
    openAddItem(){

      this.flushEntity()
      let category  = this.categories.find(el => el.value === this.selectedCategory )
      if ( category ) {
        this.entityData.category_id = !category.parent ? category.value : category.parent
        this.entityData.sub_category_id = category.value
      }

      this.displayDialog = true
      this.newEntity = true
    },
    async openEditItem(item) {

      this.newEntity = false
      this.entityData = JSON.parse(JSON.stringify(item))
      this.displayDialog = true;
    },

    // Technical
    flushEntity() {
      this.entityData = JSON.parse(JSON.stringify(this.entityDataDefault))
    },
    childCategories(parentId) {
      return this.categories.filter(el => el.parent === parentId )
    },
    courseCategoryCount(uuid) {
      let items = this.items
      if (uuid && uuid !== 'all') {
        uuid = uuid !== 'unsorted' ? uuid : null
        items = items.filter( el => el.category_id === uuid )
      }
      return items.length
    },

    // Page init
    async initPage(){
      this.flushEntity()

      let result = await this.GET_PRODUCTS_ADMIN();
      if ( !result ) { this.notify(this.$t('ConnectionError'))}
      this.items = result.products;
      this.categories = result.categories


    }
  },

  mounted() {
    this.$store.state.courses.navigationAdmin = 'editor'
    this.initPage()
    // ONBOARD_COURSES(this)
  }
}
</script>

<style scoped>

</style>